import styled from "@emotion/styled";
import {
  //  Avatar,
  Box,
  Typography,
} from "@mui/material";
import { INDIVIDUAL_PLAN_ID } from "@shared/utils/constants";

const PartnerContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 1rem;
`;

const PartnerDetails = styled(Box)`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  /* border: solid 1px ${(p) => p.theme.colors.border2}; */
  /* padding: 1rem 0.75rem; */
  border-radius: 1rem;
  width: 100%;
  background: ${(p) => p.theme.colors.background};
  color: ${(p) => p.theme.text.colors.primary};
`;

// const PartnerAvatar = styled(Avatar)`
//   width: 3.5rem;
//   height: 3.5rem;
//   border-radius: 0.5rem;
// `;

type Props = {
  partner: {
    id: string;
    name: string;
    logo?: string;
  };
};

export const PartnerCard = (props: Props) => {
  const { partner } = props;
  const isIndividualPlan = partner.id === INDIVIDUAL_PLAN_ID;

  return (
    <PartnerContainer>
      <PartnerDetails>
        {/* <PartnerAvatar
          src={partner.logo ?? partner.name}
          alt={partner.name}
          variant="rounded"
        /> */}
        <Box>
          {isIndividualPlan ? (
            <Typography variant="h6">Individual Subscription Plan</Typography>
          ) : (
            <>
              <Typography variant="h6">Membership Affiliation</Typography>
              <Typography variant="subtitle1">{partner.name}</Typography>
            </>
          )}
        </Box>
      </PartnerDetails>
    </PartnerContainer>
  );
};
